import React from 'react';
import { MenuItem, Menu, IconButton, Box, Typography } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useHistory } from 'react-router-dom';

const styles = {
    menuItemWithRedirect: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 0,
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    textArea: {
        flex: 1,
        padding: '6px 16px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'action.hover',
        },
    },
    iconButton: {
        mr: 1,
        padding: '6px',
        cursor: 'pointer',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: 'action.hover',
        },
    },
};

export const ActionCell = ({ params, disabled, options }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const history = useHistory();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAction = (action) => {
        action(params.row);
        handleClose();
    };

    const handleRedirect = (action, useRouter = false) => {
        const url = action(params.row);
        if (url) {
            if (useRouter) {
                history.push(url);
            } else {
                window.open(`/#${url}`, '_blank');
            }
        }
        handleClose();
    };

    const isDisabled = disabled && disabled(params.row);

    return (
        <>
            <IconButton aria-label="Actions" aria-controls={`actions-menu-${params.row.id}`} aria-haspopup="true" onClick={handleClick} disabled={isDisabled}>
                <MoreVertIcon />
            </IconButton>
            <Menu id={`actions-menu-${params.row.id}`} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                {options?.map((option) => {
                    if (option.shouldRender && !option.shouldRender(params.row)) return null;

                    const hasRedirect = option.redirect != null;
                    const isOptionDisabled = Boolean(option.disabled && option.disabled(params.row));

                    return (
                        <MenuItem
                            key={option.label}
                            disabled={isOptionDisabled}
                            disableRipple={hasRedirect}
                            sx={hasRedirect ? styles.menuItemWithRedirect : {}}
                            onMouseDown={
                                !hasRedirect
                                    ? undefined
                                    : (event) => {
                                          if (event.button === 1) {
                                              event.preventDefault();
                                              handleRedirect(option.redirect);
                                          }
                                      }
                            }
                        >
                            {hasRedirect ? (
                                <>
                                    <Box onClick={() => handleRedirect(option.redirect, true)} sx={styles.textArea}>
                                        <Typography variant="inherit">{option.label}</Typography>
                                    </Box>
                                    <Box
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleRedirect(option.redirect);
                                        }}
                                        sx={styles.iconButton}
                                    >
                                        <OpenInNewIcon fontSize="small" />
                                    </Box>
                                </>
                            ) : (
                                <Box sx={{ flex: 1 }} onClick={() => handleAction(option.action)}>
                                    {option.label}
                                </Box>
                            )}
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};

const ActionColumn = (props) => {
    return {
        field: 'actions',
        headerName: '',
        sortable: false,
        filterable: false,
        flex: 0.1,
        disableColumnMenu: true,
        disableExport: true,
        maxWidth: 50,
        hideable: false,
        renderCell: (params) => <ActionCell params={params} {...props} />,
    };
};

export default ActionColumn;
